export default {
	name: 'ToppageIndex',

	computed: {
		options() {
			return [
				{
					title: this.$t('test'),
					icon: 'ni ni-atom',
					button: [
						{
							btnName: this.$t('inspection'),
							disabled: false,
						},
						{
							btnName: this.$t('creationModelHistory'),
							disabled: false,
						},
					],
				},
				{
					title: this.$t('model'),
					icon: 'ni ni-user-run',
					button: [
						{
							btnName: this.$t('newModelCreattion'),
							disabled: false,
						},
						{
							btnName: this.$t('modelsManagement'),
							disabled: false,
						},
					],
				},
			];
		},
	},

	methods: {
		/**
		 * first button of single option card's click event handler
		 * @param {number} firstBtnIndex: index of options
		 */
		onClickFirstIndexBtn(firstBtnIndex) {
			switch (firstBtnIndex) {
				case 0:
					this.$router.push('/camera');

					break;
				case 1:
					this.$router.push('/trainer');
					break;
				case 2:
					break;
				default:
					break;
			}
		},

		/**
		 * second button of single option card's click event handler
		 * @param {number} secondBtnIndex: index of options
		 */
		onClickSecondIndexBtn(secondBtnIndex) {
			switch (secondBtnIndex) {
				case 0:
					this.$router.push('/history');
					break;
				case 1:
					this.$router.push('/model');
					break;
				case 2:
					break;
				default:
					break;
			}
		},
	},
};
